import { RequiredMark } from "../components/RequiredMark.js";

// A generic segmented control: a labeled row of mutually-exclusive buttons.
// Used for both the New/Existing patient toggle and the modality chooser, so
// they render identically. Generic over a string-union value type.
export function SegmentedToggle<T extends string>({
  label,
  ariaLabel,
  options,
  value,
  onChange,
  required = false,
}: {
  label: string;
  ariaLabel: string;
  options: ReadonlyArray<{ value: T; label: string }>;
  value: T;
  onChange: (value: T) => void;
  required?: boolean;
}) {
  return (
    <div>
      <span className="block text-sm font-medium text-slate-700">
        {label}
        {required ? <RequiredMark /> : null}
      </span>
      <div
        role="group"
        aria-label={ariaLabel}
        className="mt-1 inline-flex rounded-md border border-slate-300 p-0.5"
      >
        {options.map((opt) => (
          <button
            key={opt.value}
            type="button"
            aria-pressed={value === opt.value}
            onClick={() => onChange(opt.value)}
            className={
              "rounded px-4 py-1.5 text-sm font-medium capitalize transition-colors " +
              (value === opt.value
                ? "bg-blue-600 text-white"
                : "bg-white text-slate-700 hover:bg-slate-50")
            }
          >
            {opt.label}
          </button>
        ))}
      </div>
    </div>
  );
}
